export default "__VITE_ASSET__DVdyhZea__"